module.exports = __webpack_public_path__ + "static/img/customer-we.aa0b7908.png";